import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import Home from './pages/Home';
import Gisting from './pages/Gisting';
import Contact from './pages/Contact';
import RSVP from './pages/RSVP';
import Navbar from './components/navbar';
import Button from './components/button';
import RSVPLanding from './pages/RSVPLanding';
import Gallery from "./pages/Gallery";
import PrivateRoute from "./components/PrivateRoute";
import { useAuth0 } from "@auth0/auth0-react";
import Footer from './components/footer';
import NotFound from './pages/NotFound';
import NamePrompt from './components/NamePrompt';
import Party from './pages/Party';
import NewsletterArchive from './pages/NewsletterArchive';


function App() {
  const { isAuthenticated, user } = useAuth0();
  const [needsName, setNeedsName] = useState(false);

  useEffect(() => {
    if (isAuthenticated && user?.email) {
      fetch('/api/user', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: user.email }),
      })
        .then(res => res.json())
        .then(data => setNeedsName(data.needsName));
    }
  }, [isAuthenticated, user]);

  const [currentLanguage, setCurrentLanguage] = useState("IS");
  const handleLanguageChange = () => {
    setCurrentLanguage((prevLanguage) =>
      prevLanguage === "IS" ? "EN" : "IS"
    );
  };
  return (
    <div className="app-wrapper">
      {/* ... */}
      <Navbar
        currLang={currentLanguage}
        langButtonHandle={handleLanguageChange}
      />
      {needsName && (
        <NamePrompt currLang={currentLanguage} email={user.email} onNameSet={() => setNeedsName(false)} />
      )}
      <div className="content">
        <Routes>
          <Route path="/" element={<Home currLang={currentLanguage} />} />
          <Route strict path="/gisting" element={
            <PrivateRoute currLang={currentLanguage}>
              <Gisting currLang={currentLanguage} />
            </PrivateRoute>
          } />
          <Route strict path="/party" element={<Party currLang={currentLanguage} />} />
          {/* <Route strict path="/contact" element={<Contact />} /> */}
          <Route strict path="/rsvp" element={
            <PrivateRoute currLang={currentLanguage}>
              <RSVP currLang={currentLanguage} user={user} />
            </PrivateRoute>
          } />
          {/* <Route strict path="/rsvp/landing" element={<RSVPLanding currLang={currentLanguage} />} /> */}
          <Route path="*" element={<NotFound currLang={currentLanguage} />} />
          <Route strict path="/gallery" element={
            <PrivateRoute currLang={currentLanguage}>
              <Gallery />
            </PrivateRoute>
          } />
          <Route strict path="/newsletter" element={
            <PrivateRoute currLang={currentLanguage}>
              <NewsletterArchive currLang={currentLanguage} />
            </PrivateRoute>
          } />
        </Routes>
      </div>
      <Footer currLang={currentLanguage} />
    </div>
  );

}

export default App;


